// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
    faKey,
    faSearchDollar,
    faTools,
    faUniversity,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import HistoricoClienteCobranca from "../../HistoricoClienteCobranca";
import ProdutosCards from "../Produtos";
import ContatosCliente from "../../ContatosCliente";
import Documentos from "../../Documentos";

import AtendimentosAoClienteDaConta from "./AtendimentosDoCliente/AtendimentoAoCliente";

import "./styles.css";
import DadosCadastraisCliente from "./DadosCadastraisCliente";
import AtendimentosAssitenciaTecnicaClienteDaConta from "./AtendimentosDoCliente/AtendimentoAssistenciaTecnicaDoCliente";
import AtendimentosCobrancaDaConta from "./AtendimentosDoCliente/Cobranca";
import AtendimentosRepasseDaConta from "./AtendimentosDoCliente/AtendimentoRepasse";
import AtendimentoVistoriaEEntregaDeChavesDaConta from "./AtendimentosDoCliente/AtendimentoVistoriaEEntregaDeChaves";
import { useState } from "react";
import { useUserInfor } from "../../../../Context/User";
import { ACESSOS } from "../../../../Routes/Acessos";
import { useNotificacaoAlerta } from "../../../../Context/NotificacaoAlerta";
import ModalComponent from "../../../Modais";
import { useClientePage } from "../../../../Context/ClientePage";

interface IClienteCardPageGeralProps {
    idConta: number;
}

const moduloDS = {
    Cobranca: "de Cobrança",
    Atendimento: "de Atendimento ao Cliente",
    Geral: "do CRMv2",
};

export function ClienteCardPageGeral(props: IClienteCardPageGeralProps) {
    const { idConta } = props;

    const { UserInfor } = useUserInfor();

    const { Cliente, modulo } = useClientePage();
    const [mostrarAtendimentos, setMostrarAtendimentos] = useState(false);
    const [mostrarInfomacoesDaVenda, setMostrarInformacoesDaVenda] =
        useState(false);

    const { modal, setShow, show } = useNotificacaoAlerta();
    const DefaultDescAberturaDeCaso = `Atendimento aberto pela tela de Cliente ${moduloDS[modulo]}`;

    return (
        <>
            <div>
                <div className="card card-custom gutter-b">
                    <div className="card-body">
                        <ul
                            className="dashboard-tabs nav nav-pills nav-success row row-paddingless m-0 p-0 flex-column flex-sm-row"
                            role="tablist"
                        >
                            <li className="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mr-3 mb-3 mb-lg-0">
                                <a
                                    className="nav-link border py-2 d-flex flex-grow-1 rounded flex-column align-items-center active"
                                    data-toggle="pill"
                                    href="#Inforgeral"
                                >
                                    <span className="nav-icon py-2 w-auto">
                                        <span className="svg-icon svg-icon-3x">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="24"
                                                        height="24"
                                                    ></rect>
                                                    <rect
                                                        fill="#000000"
                                                        x="4"
                                                        y="4"
                                                        width="7"
                                                        height="7"
                                                        rx="1.5"
                                                    ></rect>
                                                    <path
                                                        d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
                                                        fill="#000000"
                                                        opacity="0.3"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </span>
                                    </span>
                                    <span className="nav-text font-size-lg py-2 font-weight-bold text-center">
                                        Informações Gerais
                                    </span>
                                </a>
                            </li>

                            <li
                                className="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mr-3 mb-3 mb-lg-0"
                                onClick={() =>
                                    setMostrarInformacoesDaVenda(true)
                                }
                            >
                                <a
                                    className="nav-link border py-2 d-flex flex-grow-1 rounded flex-column align-items-center"
                                    data-toggle="pill"
                                    href="#InforVendas"
                                >
                                    <span className="nav-icon py-2 w-auto">
                                        <span className="svg-icon svg-icon-3x">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect
                                                        x="0"
                                                        y="0"
                                                        width="24"
                                                        height="24"
                                                    />
                                                    <path
                                                        d="M16.0322024,5.68722152 L5.75790403,15.945742 C5.12139076,16.5812778 5.12059836,17.6124773 5.75613416,18.2489906 C5.75642891,18.2492858 5.75672377,18.2495809 5.75701875,18.2498759 L5.75701875,18.2498759 C6.39304347,18.8859006 7.42424328,18.8859006 8.060268,18.2498759 C8.06056298,18.2495809 8.06085784,18.2492858 8.0611526,18.2489906 L18.3196731,7.9746922 C18.9505124,7.34288268 18.9501191,6.31942463 18.3187946,5.68810005 L18.3187946,5.68810005 C17.68747,5.05677547 16.6640119,5.05638225 16.0322024,5.68722152 Z"
                                                        fill="#000000"
                                                        fillRule="nonzero"
                                                    />
                                                    <path
                                                        d="M9.85714286,6.92857143 C9.85714286,8.54730513 8.5469533,9.85714286 6.93006028,9.85714286 C5.31316726,9.85714286 4,8.54730513 4,6.92857143 C4,5.30983773 5.31316726,4 6.93006028,4 C8.5469533,4 9.85714286,5.30983773 9.85714286,6.92857143 Z M20,17.0714286 C20,18.6901623 18.6898104,20 17.0729174,20 C15.4560244,20 14.1428571,18.6901623 14.1428571,17.0714286 C14.1428571,15.4497247 15.4560244,14.1428571 17.0729174,14.1428571 C18.6898104,14.1428571 20,15.4497247 20,17.0714286 Z"
                                                        fill="#000000"
                                                        opacity="0.3"
                                                    />
                                                </g>
                                            </svg>
                                        </span>
                                    </span>
                                    <span className="nav-text font-size-lg py-2 font-weight-bolder text-center">
                                        Informações da venda
                                    </span>
                                </a>
                            </li>

                            <li
                                className="nav-item d-flex col-sm flex-grow-1 flex-shrink-0 mr-3 mb-3 mb-lg-0"
                                onClick={() => setMostrarAtendimentos(true)}
                            >
                                <a
                                    className="nav-link border py-2 d-flex flex-grow-1 rounded flex-column align-items-center"
                                    data-toggle="pill"
                                    href="#InforAtendimento"
                                >
                                    <span className="nav-icon py-2 w-auto">
                                        <span className="svg-icon svg-icon-3x">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <polygon points="0 0 24 0 24 24 0 24"></polygon>
                                                    <path
                                                        d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
                                                        fill="#000000"
                                                        fillRule="nonzero"
                                                        opacity="0.3"
                                                    ></path>
                                                    <path
                                                        d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
                                                        fill="#000000"
                                                        fillRule="nonzero"
                                                    ></path>
                                                </g>
                                            </svg>
                                        </span>
                                    </span>
                                    <span className="nav-text font-size-lg py-2 font-weight-bolder text-center">
                                        Atendimentos
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div className="tab-content m-0 p-0">
                    <div
                        className="tab-pane active"
                        id="Inforgeral"
                        role="tabpanel"
                    >
                        <div className="row">
                            <div className="col-12 col-lg-4 gutter-b">
                                <DadosCadastraisCliente Cliente={Cliente} />
                            </div>
                            <div className="col-12 col-lg-4 gutter-b">
                                <ContatosCliente
                                    idConta={idConta}
                                    ID_CHAVE_ERP={Cliente?.ID_CHAVE_ERP}
                                />
                            </div>
                            <div className="col-12 col-lg-4 gutter-b">
                                <div className="card card-custom card-stretch">
                                    <HistoricoClienteCobranca
                                        ID_CHAVE_ERP={Cliente?.ID_CHAVE_ERP}
                                    />
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 gutter-b">
                                <div className="card card-custom card-stretch">
                                    <Documentos
                                        IdConta={idConta}
                                        tipoExibicao="CLIENTE"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane" id="InforVendas" role="tabpanel">
                        {mostrarInfomacoesDaVenda && (
                            <ProdutosCards
                                DefaultDescAberturaDeCaso={
                                    DefaultDescAberturaDeCaso
                                }
                                idConta={idConta}
                                cliente={Cliente}
                            />
                        )}
                    </div>

                    <div
                        className="tab-pane"
                        id="InforAtendimento"
                        role="tabpanel"
                    >
                        {mostrarAtendimentos && (
                            <div className="card card-custom mb-3">
                                <div className="card-body">
                                    <div className="row">
                                        <div>
                                            <ul className="nav nav-primary nav-bold nav-pills border-bottom-0">
                                                {UserInfor.MODULOS.some(
                                                    (modulo) =>
                                                        modulo.ID_MODULO ===
                                                        ACESSOS.ATENDIMENTO
                                                            .ID_MODULO
                                                ) && (
                                                    <li className="nav-item mb-3 ml-2">
                                                        <a
                                                            className="nav-link active btn-block"
                                                            data-toggle="tab"
                                                            href="#AtendimentoCliente"
                                                        >
                                                            <span className="nav-icon">
                                                                <FontAwesomeIcon
                                                                    className="svgTrue"
                                                                    icon={
                                                                        faUsers
                                                                    }
                                                                />
                                                            </span>
                                                            <span className="nav-text">
                                                                Atendimento ao
                                                                Cliente
                                                            </span>
                                                        </a>
                                                    </li>
                                                )}
                                                {UserInfor.MODULOS.some(
                                                    (modulo) =>
                                                        modulo.ID_MODULO ===
                                                        ACESSOS.COBRANCA
                                                            .ID_MODULO
                                                ) && (
                                                    <li className="nav-item mb-2 ml-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#Cobranca"
                                                        >
                                                            <span className="nav-icon">
                                                                <FontAwesomeIcon
                                                                    className="svgTrue"
                                                                    icon={
                                                                        faSearchDollar
                                                                    }
                                                                />
                                                            </span>
                                                            <span className="nav-text">
                                                                Cobrança
                                                            </span>
                                                        </a>
                                                    </li>
                                                )}
                                                {UserInfor.MODULOS.some(
                                                    (modulo) =>
                                                        modulo.ID_MODULO ===
                                                        ACESSOS.ASSISTENCIA
                                                            .ID_MODULO
                                                ) && (
                                                    <li className="nav-item mb-2 ml-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#AssistenciaTecnica"
                                                        >
                                                            <span className="nav-icon">
                                                                <FontAwesomeIcon
                                                                    className="svgTrue"
                                                                    icon={
                                                                        faTools
                                                                    }
                                                                />
                                                            </span>
                                                            <span className="nav-text">
                                                                Assistência
                                                                Técnica
                                                            </span>
                                                        </a>
                                                    </li>
                                                )}
                                                {UserInfor.MODULOS.some(
                                                    (modulo) =>
                                                        modulo.ID_MODULO ===
                                                        ACESSOS.REPASSE
                                                            .ID_MODULO
                                                ) && (
                                                    <li className="nav-item mb-2 ml-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#Repasse"
                                                        >
                                                            <span className="nav-icon">
                                                                <FontAwesomeIcon
                                                                    className="svgTrue"
                                                                    icon={
                                                                        faUniversity
                                                                    }
                                                                />
                                                            </span>
                                                            <span className="nav-text">
                                                                Repasse
                                                            </span>
                                                        </a>
                                                    </li>
                                                )}
                                                {UserInfor.MODULOS.some(
                                                    (modulo) =>
                                                        modulo.ID_MODULO ===
                                                        ACESSOS
                                                            .ENTREGA_DE_CHAVES
                                                            .ID_MODULO
                                                ) && (
                                                    <li className="nav-item mb-2 ml-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#Vistoria"
                                                        >
                                                            <span className="nav-icon">
                                                                <FontAwesomeIcon
                                                                    className="svgTrue"
                                                                    icon={faKey}
                                                                />
                                                            </span>
                                                            <span className="nav-text">
                                                                Vistoria e
                                                                Entrega de
                                                                Chaves
                                                            </span>
                                                        </a>
                                                    </li>
                                                )}
                                                {/* <li className="nav-item w-100">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#AtendimentoWhatsapp"
                                                >
                                                    <span className="nav-icon">
                                                        <FontAwesomeIcon
                                                            className="svgTrue"
                                                            icon={faWhatsapp}
                                                        />
                                                    </span>
                                                    <span className="nav-text">
                                                        Atendimento Whatsapp
                                                    </span>
                                                </a>
                                            </li> */}
                                            </ul>
                                        </div>
                                        <div className="col-md-12 col-12">
                                            <div
                                                className="tab-content"
                                                id="myTabContent"
                                            >
                                                <div className="tab-content">
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="AtendimentoCliente"
                                                        role="tabpanel"
                                                        aria-labelledby="kt_tab_pane_5_1"
                                                    >
                                                        <AtendimentosAoClienteDaConta
                                                            ID_CONTA={idConta}
                                                            dsModulo={
                                                                "Atendimento"
                                                            }
                                                        />
                                                    </div>
                                                    <div
                                                        className="tab-pane fade"
                                                        id="Cobranca"
                                                        role="tabpanel"
                                                        aria-labelledby="kt_tab_pane_5_2"
                                                    >
                                                        <AtendimentosCobrancaDaConta
                                                            ID_CONTA={idConta}
                                                            dsModulo={
                                                                "Cobranca"
                                                            }
                                                        />
                                                    </div>
                                                    <div
                                                        className="tab-pane fade"
                                                        id="AssistenciaTecnica"
                                                        role="tabpanel"
                                                        aria-labelledby="kt_tab_pane_5_3"
                                                    >
                                                        <AtendimentosAssitenciaTecnicaClienteDaConta
                                                            ID_CONTA={idConta}
                                                            dsModulo={
                                                                "AssistenciaTecnica"
                                                            }
                                                        />
                                                    </div>
                                                    <div
                                                        className="tab-pane fade"
                                                        id="Repasse"
                                                        role="tabpanel"
                                                        aria-labelledby="kt_tab_pane_5_4"
                                                    >
                                                        <AtendimentosRepasseDaConta
                                                            ID_CONTA={idConta}
                                                            dsModulo={"Repasse"}
                                                        />
                                                    </div>
                                                    <div
                                                        className="tab-pane fade"
                                                        id="Vistoria"
                                                        role="tabpanel"
                                                        aria-labelledby="kt_tab_pane_5_5"
                                                    >
                                                        <AtendimentoVistoriaEEntregaDeChavesDaConta
                                                            ID_CONTA={idConta}
                                                            dsModulo={
                                                                "EntregaChaves"
                                                            }
                                                        />
                                                    </div>
                                                    {/* <div
                                                    className="tab-pane fade"
                                                    id="AtendimentoWhatsapp"
                                                    role="tabpanel"
                                                    aria-labelledby="kt_tab_pane_5_3"
                                                >
                                                    <AtendimentosAoClienteWhatsAppDaConta
                                                        ID_CONTA={idConta}
                                                    />
                                                </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <ModalComponent
                            setShow={setShow}
                            show={show}
                            ModalComponent={modal}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
